// extracted by mini-css-extract-plugin
module.exports = {"overTopLayer":"OverDialogLayer_overTopLayer__65R_m"};